// extracted by mini-css-extract-plugin
export default {"ingrOuterContainer":"RecipeIngredients_ingrOuterContainer__KTYaG","ingredientsList":"RecipeIngredients_ingredientsList__LfKAd"};